import useSWR from 'swr';
import { useMemo } from 'react';
import axios from 'src/utils/axios';

// ----------------------------------------------------------------------

const AI_PROCESSING_BASE =
  process.env.REACT_APP_DOC_AI_PROCESSING_API || process.env.REACT_APP_HOST_API || '';

export function useGetAIProcessingResults(claimId, options) {
  const URL = claimId
    ? `${AI_PROCESSING_BASE.replace(/\/$/, '')}/api/claims/${claimId}/results`
    : null;

  const fetcher = async (url) => {
    const res = await axios.get(url);
    return res.data;
  };

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    revalidateOnFocus: false,
    ...options,
    /** Poll until AI processing finishes; stop when status is terminal (must run after ...options). */
    refreshInterval: (latestData) => {
      const status = latestData?.overall_status;
      if (status === 'COMPLETED' || status === 'FAILED') {
        return 0;
      }
      return 3000;
    },
  });

  const memoizedValue = useMemo(
    () => ({
      results: data || null,
      resultsLoading: isLoading,
      resultsError: error,
      resultsValidating: isValidating,
      resultsEmpty: !isLoading && !data,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}
